/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Total_RevenueInputs */

const en_admin_dashboard_total_revenue = /** @type {(inputs: Admin_Dashboard_Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Revenue`)
};

const de_admin_dashboard_total_revenue = /** @type {(inputs: Admin_Dashboard_Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtumsatz`)
};

const es_admin_dashboard_total_revenue = /** @type {(inputs: Admin_Dashboard_Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresos totales`)
};

const fr_admin_dashboard_total_revenue = /** @type {(inputs: Admin_Dashboard_Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenu total`)
};

const nl_admin_dashboard_total_revenue = /** @type {(inputs: Admin_Dashboard_Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale omzet`)
};

const it_admin_dashboard_total_revenue = /** @type {(inputs: Admin_Dashboard_Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrate totali`)
};

const pt_br2_admin_dashboard_total_revenue = /** @type {(inputs: Admin_Dashboard_Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receita total`)
};

const pl_admin_dashboard_total_revenue = /** @type {(inputs: Admin_Dashboard_Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łączne przychody`)
};

const hu_admin_dashboard_total_revenue = /** @type {(inputs: Admin_Dashboard_Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összes bevétel`)
};

const ro_admin_dashboard_total_revenue = /** @type {(inputs: Admin_Dashboard_Total_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venituri Totale`)
};

/**
* | output |
* | --- |
* | "Total Revenue" |
*
* @param {Admin_Dashboard_Total_RevenueInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_total_revenue = /** @type {((inputs?: Admin_Dashboard_Total_RevenueInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Total_RevenueInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_total_revenue(inputs)
	if (locale === "de") return de_admin_dashboard_total_revenue(inputs)
	if (locale === "es") return es_admin_dashboard_total_revenue(inputs)
	if (locale === "fr") return fr_admin_dashboard_total_revenue(inputs)
	if (locale === "nl") return nl_admin_dashboard_total_revenue(inputs)
	if (locale === "it") return it_admin_dashboard_total_revenue(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_total_revenue(inputs)
	if (locale === "pl") return pl_admin_dashboard_total_revenue(inputs)
	if (locale === "hu") return hu_admin_dashboard_total_revenue(inputs)
	return ro_admin_dashboard_total_revenue(inputs)
});
export { admin_dashboard_total_revenue as "admin.dashboard.total_revenue" }